import React, { useId, useState } from 'react';
import { Box, Button, Typography } from '@mui/material';

export const FLOW_BG_KINDS = ['background', 'slide'];

export function flowBgKindLabel(kind) {
  return kind === 'slide' ? 'Slide' : 'Background';
}

/** Two horizontal buttons: Background | Slide */
export function FlowBgKindToggle({ value, onChange, disabled }) {
  return (
    <Box sx={{ display: 'flex', gap: 1 }}>
      {FLOW_BG_KINDS.map((k) => (
        <Button
          key={k}
          type="button"
          disabled={disabled}
          variant={value === k ? 'contained' : 'outlined'}
          size="small"
          onClick={() => onChange(k)}
          sx={{ flex: 1, textTransform: 'none' }}
        >
          {flowBgKindLabel(k)}
        </Button>
      ))}
    </Box>
  );
}

/** Drag-and-drop or click to pick one image */
export function ImageFileDropZone({ file, onFile, disabled, inputRef, compact = false }) {
  const [over, setOver] = useState(false);
  const inputId = useId();

  return (
    <Box
      onDragOver={(e) => {
        e.preventDefault();
        if (!disabled) setOver(true);
      }}
      onDragLeave={() => setOver(false)}
      onDrop={(e) => {
        e.preventDefault();
        setOver(false);
        if (disabled) return;
        const f = e.dataTransfer.files?.[0];
        if (f?.type.startsWith('image/')) onFile(f);
      }}
      sx={{
        border: compact ? '1px dashed' : '2px dashed',
        borderColor: over ? 'primary.main' : 'divider',
        borderRadius: compact ? 1 : 2,
        p: compact ? 1 : 3,
        py: compact ? 0.75 : undefined,
        textAlign: 'center',
        cursor: disabled ? 'default' : 'pointer',
        bgcolor: over ? 'action.hover' : 'action.selected',
        opacity: disabled ? 0.6 : 1,
        transition: 'border-color 0.15s, background-color 0.15s',
        minWidth: 0,
        maxWidth: '100%',
        boxSizing: 'border-box'
      }}
    >
      <input
        id={inputId}
        ref={inputRef}
        type="file"
        accept="image/*"
        hidden
        disabled={disabled}
        onChange={(e) => onFile(e.target.files?.[0] || null)}
      />
      <label htmlFor={inputId} style={{ cursor: disabled ? 'default' : 'pointer', display: 'block' }}>
        <Typography
          variant={compact ? 'caption' : 'body2'}
          color="text.secondary"
          sx={{
            lineHeight: compact ? 1.25 : undefined,
            wordBreak: 'break-word',
            overflowWrap: 'anywhere'
          }}
        >
          {file ? file.name : 'Drop image here or click to choose'}
        </Typography>
      </label>
    </Box>
  );
}
